import { BadgeLogoVariantType } from '../../../../../../components/badgeLogo/types/badgeLogoVariantType';
import { commonStyles } from '../commonStyles';
export const getEmptyStyles = (FOUNDATIONS, FONT) => {
    return {
        [BadgeLogoVariantType.EMPTY]: {
            ...commonStyles(FOUNDATIONS, FONT),
            container: {
                ...commonStyles(FOUNDATIONS, FONT).container,
                background_color: FOUNDATIONS.color_neutral_bg_300,
            },
        },
    };
};
//# sourceMappingURL=empty.js.map